import React, {FC} from 'react';
import Modal from "react-bootstrap/Modal";
import {Template} from "./jackpotHelper";
import {useTranslation} from "react-i18next";

interface QE {
    show: boolean,
    styles: Template
    hide: (value: boolean) => void;
    error: {
     code: number,
     message: string
 }
}
const JackpotModalError: FC <QE> = ({error, hide, show,styles}) => {
    const { t } = useTranslation();
    return (
        <Modal
            show={show}
            onHide={() => hide(false)}
            dialogClassName="modal-90w"
            aria-labelledby="example-custom-modal-styling-title"
        >
            <Modal.Header closeButton
                  style={{
                      backgroundColor: styles.colors.blockTitleBgColor,
                      color: styles.colors.fontTitleColor,
                      fontFamily: styles.fonts.titleFontFamily
                  }}
            >
                <Modal.Title id="example-custom-modal-styling-title">
                    {t('notifications.title')}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body
                style={{
                    backgroundColor: styles.colors.mainBgColor,
                    color: styles.colors.fontColor

                }}
            >
                <p className='text-center'>
                    {
                        error.message
                    }
                    <br/>
                    Error Code #{
                    error.code
                    }
                </p>
            </Modal.Body>
        </Modal>
    );

}

export default JackpotModalError;
